export default "__VITE_ASSET__ZGu0jMJl__"